import * as React from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

const ConfirmationNotification = (props) => {
  const [show, setShow] = React.useState(true);
	const { t } = useTranslation();
	
  const closeConfirmationBox = () => {
    setShow(false);
  };
  return (
    <div className="z-index">
      {show && (
        <div className="margin-top-1" style={{ marginBottom: "-1rem" }}>
          <div className="ant-notification-notice confirm-notification-alert margin-auto ant-notification-notice-closable">
            <div className="ant-notification-notice-content ant-notification-notice-content--custom ">
              <div className="" role="alert">
                <div className="ant-notification-notice-message font-weight-bold">
                  {t('RECEIVING_NOTIFICATIONS')}
                </div>
                <p className="ant-notification-notice-description">
                  {t('RECEIVING_NOTIFICATIONS_DESCRIPTION')}
                </p>
                <div className="direction-rtl">
                  <Button
                    className="font-weight-bold margin-left-1 margin-bottom-0 confirmation-btn cancel-btn"
                    onClick={closeConfirmationBox}
                  >
                    {t('CANCEL')}
                  </Button>
                  <Button
                    className="font-weight-bold margin-bottom-0 enable-btn confirmation-btn"
                    onClick={props.enableConfirmationBox}
                  >
                    {t('ENABLE')}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ConfirmationNotification;
